import React from 'react';
import Header from '../../components/Header';
import StoreManagerRequestsTable from '../../tables/StoreManagement/StoreManagerRequestsTable';

const StoreManagerStockToDispatchPage = () => {



    return ( 
        <>
        <div className="min-h-screen bg-[#F6F7F6]">
            <Header text="Stock Requests to Dispatch" />
             <div className="mt-6">
                <StoreManagerRequestsTable 
                    allowedTabs={['processing', 'dispatched']}
                    initialTab="processing"
                    customTitle="Dispatch Queue"
                    showSearch={true}
                />
            </div>
        </div>
        </>
     );
}
 
export default StoreManagerStockToDispatchPage;